import React, { useEffect, useRef } from "react";
import { css } from "@emotion/react";

const Tweet: React.FC<{ id: string; width: number; height: number }> = ({
  id,
  width,
  height,
}) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Twitterの埋め込みスクリプトを動的に読み込む
    const loadTwitterScript = () => {
      const script = document.createElement("script");
      script.src = "https://platform.twitter.com/widgets.js";
      script.async = true;
      ref.current?.appendChild(script);
    };

    // 既にTwitterのスクリプトが読み込まれている場合は、widgets.loadを呼び出して更新
    if (window.twttr && window.twttr.widgets && window.twttr.widgets.load) {
      window.twttr.widgets.load(ref.current);
    } else {
      // そうでない場合は、スクリプトを読み込む
      loadTwitterScript();
    }
  }, [id]);

  return (
    <div
      dangerouslySetInnerHTML={{ __html: generateEmbedHtml(id) }}
      ref={ref}
      css={mainStyle(width, height)}
    />
  );
};

const generateEmbedHtml = (id: string): string => {
  if (!/^\d+$/u.test(id)) {
    throw new Error(`Invalid tweet ID: ${id}`);
  }

  return `<blockquote class="twitter-tweet"><a href="https://twitter.com/i/status/${id}"></a></blockquote>`;
};

const mainStyle = (width: number, height: number) => css`
  width: ${width}px;
  max-height: ${height}px;
`;

export default Tweet;
